import { createFileRoute } from "@tanstack/react-router";
import Annex1ResourceCenter from "@/pages/Annex1ResourceCenter";

const title = "Annex 1 Resource Center | QbD Group";
const description =
  "Explore practical EU GMP Annex 1 guidance, webinars, tools and expert insights on contamination control, cleanrooms, personnel and utilities.";

export const Route = createFileRoute("/en/annex-1-resource-center")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/webinar-images/annex1-webinar-featured-tablet.png" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/webinar-images/annex1-webinar-featured-tablet.png" },
    ],
    links: [{ rel: "canonical", href: "https://qbdgroup.com/en/annex-1-resource-center" }],
  }),
  component: Annex1ResourceCenter,
});
